module.exports = __webpack_public_path__ + "static/media/poll.ed6fd6ce.svg";